
(function () {
  'use strict';

  var SINK = '.cd-null-sink';

  /* Text/markup that is safe to copy across wholesale — none of these hold
     an image or an input the shopper may be interacting with. */
  var SWAP_HTML = [
    '.cdi__prices',
    '.cdi__variant',
    '.fsb-host',
    '.totals',
    '.cart-drawer__footer > div:first-child',
    '.cart-item__error-text',
    '.js-contents-shiping',
    '.tax-note'
  ];

  function itemKeys(root) {
    return Array.prototype.map
      .call(root.querySelectorAll('.cart-item'), function (el) { return el.id; })
      .join('|');
  }

  function patch(liveRoot, freshRoot) {
    /* Lines added or removed: the structure changed, so a straight swap is
       both correct and unavoidable. */
    if (itemKeys(liveRoot) !== itemKeys(freshRoot)) return false;

    SWAP_HTML.forEach(function (sel) {
      var live = liveRoot.querySelectorAll(sel);
      var fresh = freshRoot.querySelectorAll(sel);
      if (live.length !== fresh.length) return;
      for (var i = 0; i < live.length; i += 1) {
        if (live[i].innerHTML !== fresh[i].innerHTML) live[i].innerHTML = fresh[i].innerHTML;
      }
    });

    var liveSv = liveRoot.querySelector('.cart-savings');
    var freshSv = freshRoot.querySelector('.cart-savings');
    if (freshSv && !liveSv) {
      var liveTotals = liveRoot.querySelector('.cart-drawer__footer .totals');
      if (liveTotals) liveTotals.insertAdjacentElement('afterend', freshSv.cloneNode(true));
    } else if (!freshSv && liveSv) {
      liveSv.remove();
    } else if (freshSv && liveSv && liveSv.innerHTML !== freshSv.innerHTML) {
      liveSv.innerHTML = freshSv.innerHTML;
    }

    /* Line-level discount badges appear and disappear as codes are applied,
       so the list may exist on one side only — a straight innerHTML copy
       cannot handle that. */
    var liveItems = liveRoot.querySelectorAll('.cart-item');
    var freshItems = freshRoot.querySelectorAll('.cart-item');
    for (var k = 0; k < liveItems.length; k += 1) {
      var liveCell = liveItems[k].querySelector('.cart-item__details');
      var freshCell = freshItems[k] && freshItems[k].querySelector('.cart-item__details');
      if (!liveCell || !freshCell) continue;

      var liveList = liveCell.querySelector('.discounts');
      var freshList = freshCell.querySelector('.discounts');

      if (!freshList && liveList) {
        liveList.remove();
      } else if (freshList && !liveList) {
        liveCell.appendChild(freshList.cloneNode(true));
      } else if (freshList && liveList && liveList.innerHTML !== freshList.innerHTML) {
        liveList.innerHTML = freshList.innerHTML;
      }
    }

    /* Quantity fields: value and the bounds Shopify may have clamped to. */
    var liveQ = liveRoot.querySelectorAll('.quantity__input');
    var freshQ = freshRoot.querySelectorAll('.quantity__input');
    if (liveQ.length === freshQ.length) {
      for (var j = 0; j < liveQ.length; j += 1) {
        var l = liveQ[j];
        var f = freshQ[j];
        /* Leave the field the shopper is typing in alone. */
        if (document.activeElement !== l && l.value !== f.value) l.value = f.value;
        ['min', 'max', 'step', 'data-cart-quantity'].forEach(function (a) {
          var v = f.getAttribute(a);
          if (v === null) l.removeAttribute(a);
          else if (l.getAttribute(a) !== v) l.setAttribute(a, v);
        });
      }
    }

    /* Empty-state and error classes on the wrapper. */
    var liveInner = liveRoot.querySelector('.drawer__inner');
    var freshInner = freshRoot.querySelector('.drawer__inner');
    if (liveInner && freshInner && liveInner.className !== freshInner.className) {
      liveInner.className = freshInner.className;
    }

    return true;
  }

  function fullSwap(html) {
    var live = document.querySelector('.drawer__inner');
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    if (live && fresh) live.innerHTML = fresh.innerHTML;
  }

  function install() {
    var Ctor = customElements.get('cart-drawer-items');
    if (!Ctor || Ctor.prototype.__smoothPatched) return !!Ctor;

    var proto = Ctor.prototype;
    proto.__smoothPatched = true;

    var origSections = proto.getSectionsToRender;
    proto.getSectionsToRender = function () {
      var list = origSections.call(this);
      return list.map(function (s) {
        if (s.selector === '.drawer__inner') {
          return { id: s.id, section: s.section, selector: SINK };
        }
        return s;
      });
    };

    var origInner = proto.getSectionInnerHTML;
    proto.getSectionInnerHTML = function (html, selector) {
      if (selector !== SINK) return origInner.call(this, html, selector);

      try {
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var liveRoot = document.querySelector('#CartDrawer');
        var freshRoot = fresh.querySelector('#CartDrawer');
        if (!liveRoot || !freshRoot || !patch(liveRoot, freshRoot)) fullSwap(html);
      } catch (e) {
        fullSwap(html);
      }

      /* The sink stays empty; the real update has already happened. */
      return '';
    };

    return true;
  }

  if (!install()) {
    /* cart-drawer.js is deferred too, so the element may not be defined yet. */
    customElements.whenDefined('cart-drawer-items').then(install);
  }
})();
